import { render, staticRenderFns } from "./ylw.vue?vue&type=template&id=7c59830c&scoped=true&"
var script = {}
import style0 from "./ylw.vue?vue&type=style&index=0&id=7c59830c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59830c",
  null
  
)

export default component.exports